import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {OAuthStorage} from 'angular-oauth2-oidc';

const APP_PREFIX = environment.appPrefix;

@Injectable({
    providedIn: 'root'
})
export class LocalStorageService extends OAuthStorage{
    constructor() {
        super();
    }

    static loadInitialState(): any {
        return Object.keys(localStorage).reduce((state: any, storageKey) => {
            if (storageKey.includes(APP_PREFIX)) {
                const stateKeys = storageKey
                    .replace(APP_PREFIX, '')
                    .toLowerCase()
                    .split('.')
                    .map((key) =>
                        key
                            .split('-')
                            .map((token, index) =>
                                index === 0
                                    ? token
                                    : token.charAt(0).toUpperCase() + token.slice(1)
                            )
                            .join('')
                    );
                let currentStateRef = state;
                stateKeys.forEach((key, index) => {
                    if (index === stateKeys.length - 1) {
                        currentStateRef[key] = JSON.parse(localStorage.getItem(storageKey));
                        return;
                    }
                    currentStateRef[key] = currentStateRef[key] || {};
                    currentStateRef = currentStateRef[key];
                });
            }
            return state;
        }, {});
    }

    setItem(key: string, value: any): void {
        localStorage.setItem(`${APP_PREFIX}${key}`, JSON.stringify(value));
    }

    getItem(key: string): any {
        return JSON.parse(localStorage.getItem(`${APP_PREFIX}${key}`));
    }

    removeItem(key: string): void {
        localStorage.removeItem(`${APP_PREFIX}${key}`);
    }

    /** Tests that localStorage exists, can be written to, and read from. */
    testLocalStorage(): any {
        const testValue = 'testValue';
        const testKey = 'testKey';
        const errorMessage = 'localStorage did not return expected value';

        this.setItem(testKey, testValue);
        const retrievedValue = this.getItem(testKey);
        this.removeItem(testKey);

        if (retrievedValue !== testValue) {
            throw new Error(errorMessage);
        }
    }

    setAccessToken(accessToken: string): void {
        this.setItem('access_token', accessToken);
    }

    setIdToken(idToken: string): void {
        this.setItem('id_token', idToken);
    }

    setLanguage(language: string): void {
        this.setItem('language_translation', language);
    }

    getLanguage(): string {
        return this.getItem('language_translation');
    }
}
